import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import { sanitisedRoutesOfSupport } from '~/routes/groups/support';
import Navvy from './navvy';
import { NavSmartActions } from '~/components/nav/nav-smart-actions';
import useSmartNav from '~/hooks/use-smart-nav';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import DesktopTitledLayout from './desktop-layout';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import RequireCustomer from './require-customer';
import { Suspense, useMemo } from 'react';
import MobileLayout from './mobile-layout';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { currentPageRoute, showSmartActions } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);
  const sanitisedRoutesOfSupportMemo = useMemo(() => sanitisedRoutesOfSupport(), []);

  if (currentPageRoute === RoutingConstants.SupportTickets_Raise) {
    return <Outlet />;
  }

  if (isXs) {
    return (
      <MobileLayout>
        {showSmartActions && (
          <Suspense>
            <RequireCustomer isXs={isXs} silent={true}>
              <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
            </RequireCustomer>
          </Suspense>
        )}
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={t('SUPPORT_AREA_TITLE', { defaultValue: 'Support' })}>
      <Suspense>
        <Navvy routes={sanitisedRoutesOfSupportMemo} prefix="SUPPORT" />
      </Suspense>
      {showSmartActions && (
        <Suspense>
          <RequireCustomer isXs={isXs} silent={true}>
            <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
          </RequireCustomer>
        </Suspense>
      )}
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'My Support';
